<template>
	<div class="baoleft">
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==1}" :underline="false"
			@click="tianbaoxinxi">填报个人信息</el-link>
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==2}" :underline="false" @click="photo"
			v-if="$store.state.token!==''">上传照片</el-link>
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==3}" :underline="false" @click="status"
			v-if="$store.state.token!==''">查看报名状态</el-link>
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==4}" :underline="false" @click="printbaoming"
			v-if="$store.state.token!=='' && ($store.state.userexaminfo.checked==2 || $store.state.userexaminfo.checked==4)">
			打印报名表</el-link>
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==5}" :underline="false" @click="pay"
			v-if="$store.state.token!=='' && ($store.state.userexaminfo.checked==2 || $store.state.userexaminfo.checked==4 ) && payshow">
			网上缴费</el-link>
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==6}" :underline="false" @click="printzheng"
			v-if="$store.state.token!=='' && $store.state.userexaminfo.checked==4 && zkzshow ">打印准考证</el-link>
		<!-- <el-link class="baoleftp" :class="{active:$store.state.leftnavshow==9}" :underline="false" @click="mianshi"
			v-if="$store.state.token!=='' && $store.state.userexaminfo.checked==4 && zkzshow ">打印准考证</el-link> -->
		<!--		<el-link class="baoleftp active" @click="printzheng" >打印准考证</el-link>-->
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==7}" :underline="false" @click="chengji"
			v-if="$store.state.token!=='' && $store.state.userexaminfo.checked==4 && resultshow">查看成绩</el-link>
		<el-link class="baoleftp" :class="{active:$store.state.leftnavshow==8}" :underline="false" @click="mianshi"
			v-if="$store.state.token!==''&&mianshishow ">打印面试通知单</el-link>
	</div>
</template>

<script>
	import {
		examDetail,
		examineeInfo,
		examinationResult
	} from "@/api/api";
	// import {dateFtt} from "@/util/datefomat"
	import $ from "jquery";

	export default {
		data() {
			return {
				show: 1,
				zkzshow: false,
				resultshow: false,
				payshow: false,
				mianshishow: false
			}
		},
		created() {
			var servetime = new Date($.ajax({
				type: "HEAD",
				async: false,
				cache: false
			}).getResponseHeader("Date"));

			this.show = this.$store.state.leftnavshow;
			if (this.$store.state.commitread != 1 && this.$store.state.firstdo == 1) {
				this.$router.push({
					path: '/xieyi'
				})
			} else if (this.$store.state.tipsread != 1 && this.$store.state.firstdo == 1) {
				this.$router.push({
					path: '/tishi'
				})
			}
			examDetail({
				"id": this.$store.state.examid
			}).then(res => {

				console.log(Date.parse(res.data.data.payBeginTime.replace(/-/g, "/")), "22222222222")
				console.log(Date.parse(servetime) < Date.parse(res.data.data.payEndTime.replace(/-/g, "/")),
					"22222222222")
				// console.log("Date.parse(servetime)<Date.parse(res.data.data.admissionTicketEndDate)"+(Date.parse(servetime)<Date.parse(res.data.data.admissionTicketEndDate)));
				// console.log("Date.parse(servetime)>Date.parse(res.data.data.admissionTicketBeginDate)"+(Date.parse(servetime)>Date.parse(res.data.data.admissionTicketBeginDate)));
				// console.log("servetime:"+dateFtt("yyyy/MM/dd hh:mm:ss",servetime));
				// console.log("servetime:"+Date.parse(servetime));
				// console.log("Date.parse(res.data.data.admissionTicketEndDate):"+Date.parse(res.data.data.admissionTicketEndDate.replace(/-/g,"/")));
				// console.log("Date.parse(res.data.data.admissionTicketEndDate):"+res.data.data.admissionTicketEndDate.replace(/-/g,"/"));
				// console.log("Date.parse(res.data.data.admissionTicketBeginDate):"+res.data.data.admissionTicketBeginDate.replace(/-/g,"/"));
				// console.log("Date.parse(res.data.data.admissionTicketBeginDate):"+Date.parse(res.data.data.admissionTicketBeginDate));

				if (Date.parse(servetime) < Date.parse(res.data.data.admissionTicketEndDate.replace(/-/g, "/")) &&
					Date.parse(servetime) > Date.parse(res.data.data.admissionTicketBeginDate.replace(/-/g, "/"))
				) {
					this.zkzshow = true
				}
				if (Date.parse(servetime) > Date.parse(res.data.data.payBeginTime.replace(/-/g, "/")) && Date
					.parse(servetime) < Date.parse(res.data.data.payEndTime.replace(/-/g, "/"))) {
					console.log('4444444444444')
					this.payshow = true
				}
				if (Date.parse(servetime) > Date.parse(res.data.data.resultBeginTime.replace(/-/g, "/")) && Date
					.parse(servetime) < Date.parse(res.data.data.resultEndTime.replace(/-/g, "/"))) {
					this.resultshow = true
				}
				if (Date.parse(servetime) > Date.parse(res.data.data.mianshiBeginTime.replace(/-/g, "/")) && Date
					.parse(servetime) < Date.parse(res.data.data.mianshiEndTime.replace(/-/g, "/"))) {
					this.mianshishow = true
				}
				console.log(Date.parse(servetime) < Date.parse(res.data.data.payEndTime.replace(/-/g, "/")),
					"22222222222")

			})

			if (this.$store.state.firstdo == 0) {
				examineeInfo({
					'examinationId': this.$store.state.examid
				}, this.$store.state.token).then(res => {
					let userinfo = res.data.data[0];
					// console.log("JSON.parse(res.data.data[0].familyMembers):"+JSON.parse(res.data.data[0].familyMembers))
					userinfo.familyMembers = JSON.parse(res.data.data[0].familyMembers)
					this.$store.commit('updateUserexaminfo', userinfo);
					this.form = res.data.data[0];
					if (this.$store.state.userexaminfo.checked == -1 || this.$store.state.userexaminfo.checked ==
						3) {
						this.disable = false
					} else if (this.$store.state.userexaminfo.checked == 5) {
						this.disable = false
					}
				})
			} else if (this.$store.state.firstdo == 1) {
				this.disable = false
			}
			examinationResult({
				'examinationId': this.$store.state.examid
			}, this.$store.state.token).then(res => {
				if (res.data.data.length > 0) {


					if (res.data.data[0].mianshiFlag == 1) {
						this.mianshishow = true
					} else {
						this.mianshishow = false
					}
				}
			})
		},
		methods: {
			tianbaoxinxi() {

				this.$store.commit('modifyshow', 1);
				if (this.$store.state.examid == 28 || this.$store.state.examid == 19) {
					this.$router.push({
						path: '/tianbaoxinxi'
					})
				}

				if (this.$store.state.examid == 23 || this.$store.state.examid == 34) {
					this.$router.push({
						path: '/tianbaoxinxi2'
					})
				}
			},
			status() {
				this.$store.commit('modifyshow', 3);
				this.$router.push({
					path: '/status'
				})

			},
			photo() {
				this.$store.commit('modifyshow', 2);
				this.$router.push({
					path: '/photo'
				})

			},
			pay() {
				if (this.$store.state.examid == 23 || this.$store.state.examid == 34) {
					this.$router.push({
						path: '/pay'
					})
					this.$store.commit('modifyshow', 5);
					return false
				}

				this.$router.push({
					path: '/pay2'
				})
				this.$store.commit('modifyshow', 5);
				return false


			},
			printbaoming() {
				this.$store.commit('modifyshow', 4);
				this.$router.push({
					path: '/printbaoming'
				})
			},
			printzheng() {
				this.$store.commit('modifyshow', 6);
				this.$router.push({
					path: '/printzheng'
				})
			},
			chengji() {
				this.$store.commit('modifyshow', 7);
				this.$router.push({
					path: '/chengji'
				})
			},
			mianshi() {
				this.$store.commit('modifyshow', 8);
				this.$router.push({
					path: '/mianshi'
				})
			}
		}

	}
</script>

<style>
	.baoimeg {
		width: 180px;
		display: block;
		height: 64px;
		line-height: 64px;
	}

	.baoleft {
		float: left;
		color: #000;
		width: 180px;
		min-height: 640px;
		background-color: #ECF4FF;
	}

	.baoleftp {
		float: left;
		font-size: 14px;
		display: block;
		width: 180px;
		line-height: 64px;
		border-bottom: 1px solid #DBE4ED;
	}

	.active {
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		color: #ffffff !important;
		font-size: 16px;
	}
</style>